import React from 'react';
import cellTemplates from './gridCellTemplates';

const mapCellData = (column, row) => {
  const content = row[column.field];
  // Determine additional className
  let additionalClass = '';
  if (column.className) {
    additionalClass = typeof column.className === 'function'
      ? column.className(row)
      : column.className;
  }
  const contentClasses = `td-content${column.cellCss ? ' ' + column.cellCss : ''}${additionalClass ? ' ' + additionalClass : ''}`;
  return (
    <div className={contentClasses} style={{ 'width': column.width, 
      'overflow': column.hidden ? 'hidden' : 'auto',
      'visibility': column.hidden ? 'hidden' : 'visible', 
      'height': column.hidden ? '0' : 'auto' }}>
      {content}
    </div>
  );
};

const GridCell = (props) => {
  const Template = props.column.cellTemplate && cellTemplates[props.column.cellTemplate];
  if (Template) {
    return <Template { ...props } />;
  }

  return (
    <td className="base-td">{mapCellData(props.column, props.row)}</td>
  );
};

export default GridCell;


// WEBPACK FOOTER //
// ./src/common/core/grid/GridCell.jsx